import { useEffect } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;
`;

const VideoEl = styled.video`
  height: 100%;
  width: 100%;
`;

const AudioEl = styled.audio``;

const Video = ({ client, isLocal, idx }) => {
  // ALSO UPDATES EACH TIME A RECONNECT HAPPENS
  useEffect(() => {
    const videoEL = document.getElementById(`video-${idx}`);

    videoEL.srcObject = client.videoTrack;
    videoEL.setAttribute('playsinline', true);
    videoEL.setAttribute('muted', true); // for some mobile devices
    videoEL.play();

    const audioEL = document.getElementById(`audio-${idx}`);

    audioEL.srcObject = client.audioTrack;
    audioEL.setAttribute('playsinline', true);
    audioEL.setAttribute('autoplay', true);
    audioEL.play();
  }, [client]);

  return (
    <Wrapper>
      <VideoEl id={`video-${idx}`} autoplay muted />
      <AudioEl id={`audio-${idx}`} autoplay />
    </Wrapper>
  );
};

export default Video;
